import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { NonceService } from './app/NonceService';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
// .then(() => {
//   const injector = platformBrowserDynamic().injector;
//   const nonceService = injector.get(NonceService);
//    const nonce = nonceService.generateNonce();
  
//   // Inject nonce into CSP
//   const metaTag = document.createElement('meta');
//   metaTag.httpEquiv = 'Content-Security-Policy';
//   metaTag.content = `default-src 'self'; style-src 'self' https://fonts.googleapis.com 'nonce-${nonce}'; font-src 'self' https://fonts.gstatic.com; script-src 'self' 'nonce-${nonce}';`;
//   document.head.appendChild(metaTag);
//    })
  
  .catch(err => console.error(err));
